import { z } from 'zod';

// Skema respons GET /v4/booking/{id}/channex-mapping.
// Semua field nullable: booking bisa berasal dari OTA lain (bukan Channex),
// atau belum ter-mapping ke room type / rate plan Channex sama sekali.
export const BookingChannexMappingResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        channex_room_type_id: z.string().nullable(),
        channex_room_type_name: z.string().nullable(),
        channex_rate_plan_id: z.string().nullable(),
        channex_rate_plan_name: z.string().nullable(),
        ota_name: z.string().nullable(),
    }),
});

export type BookingChannexMappingResponseType = z.infer<typeof BookingChannexMappingResponse>;
export type BookingChannexMappingData = z.infer<typeof BookingChannexMappingResponse>['data'];
